import styled from 'styled-components';

export const VideoModalStyles = styled.div`
  .modal {
    display: block;
    background: rgba(45, 50, 59, 0.8);
    z-index: 99999;

    .modal-dialog {
      top: 50%;
      transform: translateY(-50%);

      .modal-body {
        padding: 0;
      }
    }
  }
`;
